<template>
    <div>
        <vx-card>
            <div slot="no-body" class="tabs-container px-6 pt-6">
                <div class="vx-row">
                    <!-- <h3 class="ml-2">Thông tin tài sản</h3> -->
                </div>
                <div class="vx-row">
                    <div class="vx-col md:w-1/3 w-full mt-2">
                        <label class="vs-input--label">{{ $t('updateInout.branch') }}</label>
                        <span class="text-danger">*</span>
                        <v-select class="" v-model="branchModel" :clearable="false" :options="branchOptions"
                                  data-vv-validate-on="blur" :disabled="isUpdate" v-validate="'required'" name="branch">
                            <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('branch') }}</span>
                    </div>
                    <div class="vx-col md:w-1/3 w-full mt-2">
                        <label class="vs-input--label">{{ $t('updateInout.employeeStaff') }}</label>
                        <span class="text-danger">*</span>
                        <v-select class="" v-model="employeeModel" :clearable="false" :options="employeeOptions"
                                  data-vv-validate-on="blur" :disabled="isUpdate" v-validate="'required'"
                                  name="employeeCode">
                            <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('employeeCode') }}</span>
                    </div>
                    <div class="vx-col md:w-1/3 w-full mt-2">
                        <label class="vs-input--label">{{ $t('updateInout.dateTimekeeping') }}</label>
                        <span class="text-danger">*</span>
                        <datepicker :format="'dd/MM/yyyy'" v-model="dateInOutChange" :highlighted="highlightedFn"
                                    :disabledDates="disabledFn" data-vv-validate-on="input" :disabled="isUpdate"
                                    v-validate="'required'" name="date"></datepicker>
                        <span class="text-danger text-sm">{{ errors.first('date') }}</span>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col md:w-1/3 w-full mt-2">
                        <label class="vs-input--label">{{ $t('updateInout.status') }}</label>
                        <v-select class="" v-model="inOutStatusModel" :clearable="false" :options="inOutStatusOptions"
                                  data-vv-validate-on="blur" v-validate="'required'" name="leaveStatus">
                            <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                        </v-select>
                    </div>
                    <div class="vx-col md:w-1/3 w-full mt-2">
                        <label class="vs-input--label">{{ $t('updateInout.shiftWork') }}</label>
                        <span class="text-danger">*</span>
                        <v-select class="" v-model="workShiftMode" :disabled="isUpdate" :clearable="false"
                                  :options="workShiftData" data-vv-validate-on="blur" v-validate="'required'"
                                  name="workshift">
                            <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('workshift') }}</span>
                    </div>
                    <div class="vx-col"
                         v-if="this.subWorkShiftOptions.length > 0 && !isUpdate && this.isShowDetails == false">
                        <feather-icon class="mt-10" icon="PlusIcon"
                                      svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                                      @click="showWorkShiftDetails"/>
                    </div>
                    <div class="vx-col lg:w-1/6 md:w-1/2 w-1/2 mt-2"
                         v-if="this.subWorkShiftOptions.length > 0 && this.isShowDetails == true">
                        <label class="vs-input--label">Thời gian</label>
                        <span class="text-danger">*</span>
                        <v-select v-model="subWorkShift" :disabled="isUpdate" :clearable="false"
                                  :options="subWorkShiftOptions"
                                  @input="workshift => updateTimeSpan(this.info, workshift)"
                                  v-validate="'required'" name="workShiftLeave">
                            <span slot="no-options">{{ $t('vSelect.noRowsToShow') }}</span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('workShiftLeave') }}</span>
                    </div>
                    <div class="vx-col"
                         v-if="this.subWorkShiftOptions.length > 0 && !isUpdate && this.isShowDetails == true">
                        <feather-icon class="mt-10" icon="XIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                                      @click="hiddenWorkShiftDetails"/>
                    </div>

                </div>
                <div class="vx-row">
                    <div class="vx-col md:w-1/2 w-full mt-5">
                        <label class="vs-input--label">{{ $t('updateInout.reason') }}</label>
                        <span class="text-danger">*</span>
                        <vs-textarea class="w-full" v-model="info.reason" :disabled="isUpdate"
                                     data-vv-validate-on="blur" v-validate="'required'" name="reason"/>
                        <span class="text-danger text-sm">{{ errors.first('reason') }}</span>
                    </div>
                    <div class="vx-col md:w-1/2 w-full mt-5">
                        <label class="vs-input--label">{{ $t('updateInout.humanCom') }}</label>
                        <vs-textarea class="w-full" v-model="info.comment" data-vv-validate-on="blur" name="comment"/>
                        <span class="text-danger text-sm">{{ errors.first('comment') }}</span>
                    </div>
                </div>
                <!-- Save & Reset Button -->
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <div class="mt-8 flex flex-wrap items-center justify-end mb-5">
                            <vs-button class="ml-auto mt-2" @click="saveChanges"
                                       v-if="(!isUpdate && isPermissionAdd()) || (isUpdate && isPermissionUpdate())">
                                {{ isUpdate ? $t('button.update') : $t('button.create') }}
                            </vs-button>
                            <vs-button class="ml-4 mt-2" type="border" color="warning" @click="inOutList"
                                       v-if="!inOutId"> {{
                                    $t('button.back')
                                }}
                            </vs-button>
                        </div>
                    </div>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>

import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker';
import utils from "../../../components/utils";
import moment from 'moment';
import {isAPI} from '../../../store/permission';
import {constAPI} from '../../../store/constant';

export default {
    components: {
        vSelect,
        Datepicker
    },
    props: {
        inOutId: {
            type: Number,
            required: true
        },
        branchId: {
            type: Number,
            required: true
        },
    },
    data() {
        return {
            highlightedFn: {
                customPredictor(date) {
                    if (moment(new Date()).format('YYYY-MM-DD') == moment(new Date(date)).format('YYYY-MM-DD')) {
                        return true;
                    }
                }
            },
            user_data: null,
            activeTab: 0,
            isUpdate: false,
            isUpdateFace: false,
            branchOptions: [],
            employeeOptions: [],
            inOutStatusOptions: [
                {value: 0, label: this.$t('statusActive.waiting')},
                {value: 1, label: this.$t('statusActive.approved')},
                {value: 2, label: this.$t('statusActive.decline')},
                {value: 3, label: this.$t('statusActive.canceled')}
            ],
            durationOptions: [
                {value: 0, label: 'Cả ngày'},
                {value: 1, label: 'Thời gian cố định'}
            ],
            info: {},
            disabledFn: {
                customPredictor(date) {
                    let today = new Date();
                    // today = today.setDate(today.getDate());
                    if (date.getTime() >= new Date(today).getTime()) {
                        return true; // returns true if disabled
                    }
                }
            },
            workShiftSetting: [],
            timeSpans: [],
            file: '',
            fileName: 'Thêm dữ liệu khuôn mặt.',
            uploadPercent: 0,
            isShowPercent: false,
            workShiftData: [],
            // dateInOutChange: new Date().setDate(new Date().getDate() - 1),
            dateInOutChange: new Date(),
            subWorkShiftOptions: [],
            isShowDetails: false,
            subWorkShift: {},
        }
    },
    async created() {
        let timeDuration = 30, timeSpans = [];
        for (let i = 0; i < 24 * 60; i = i + timeDuration) {
            timeSpans.push({value: i, label: utils.minuteToHour(i)});
        }
        this.timeSpans = timeSpans;
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.filter(el => el.organizationBranchType !== 3).map(x => {
            return {label: x.organizationBranchName, value: x.id}
        });

        this.info = {
            organizationBranchId: this.branchId ? this.branchId : this.$route.query.branch_id,
            employeeId: null,
            status: 0,
            duration: 0,
            workShiftId: null
        };
        this.info.date = new Date();
        await this.loadEmployee();
        let id = this.inOutId ? this.inOutId : this.$route.query.id;
        if (id) {
            this.isUpdate = true;
            this.$vs.loading();
            this.$crm.get(`/work-shift/employee/admin-find-update-in-out-by-id/${id}`).then((response) => {
                this.$vs.loading.close();
                this.info = response.data;
                this.info.workShiftId = response.data.workShiftId;
                this.info.employeeWorkShiftByDayId = response.data.employeeWorkShiftByDayId;
                // this.info.fromHourString = new Date(response.data.startHour).getHours() + ":" + new Date(response.data.startHour).getMinutes();
                // this.info.fromHour = new Date(response.data.startHour).getMinutes() * 60 + new Date(response.data.startHour).getMinutes();
                // this.info.toHourString = new Date(response.data.endHour).getHours() + ":" + new Date(response.data.endHour).getMinutes();
                // this.info.toHour = new Date(response.data.endHour).getMinutes() * 60 + new Date(response.data.endHour).getMinutes();
                this.dateInOutChange = this.info.date;
                this.getWorkShiftDetails(this.info.workShiftId)
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        }
    },
    watch: {
        'dateInOutChange': function () {
            this.info.date = this.dateInOutChange,
                this.changeDateInOut()
        },
    },
    computed: {
        branchModel: {
            get() {
                return {
                    label: this.branchOptions.find(x => x.value == this.info.organizationBranchId).label,
                    value: this.info.organizationBranchId
                }
            },
            set(obj) {
                this.info.organizationBranchId = obj.value;
                if (!this.isUpdate) this.clearWorkShift();
                this.loadEmployee()
                this.hiddenWorkShiftDetails()
            }
        },
        employeeModel: {
            get() {
                let object = this.employeeOptions.find(el => el.value === this.info.employeeId);
                if (!object) return
                return {
                    label: object.label,
                    value: object.value
                }
            },
            set(obj) {
                this.info.employeeId = obj.value;
                if (!this.isUpdate) this.clearWorkShift();
                this.getWorkShiftByEmployee()
                this.hiddenWorkShiftDetails()
            }
        },
        inOutStatusModel: {
            get() {
                return {
                    label: this.getLabelString(this.inOutStatusOptions.find(x => x.value == this.info.status)),
                    value: this.info.status
                }
            },
            set(obj) {
                this.info.status = obj.value;
            }
        },
        workShiftMode: {
            get() {
                return {
                    label: this.getLabelString(this.workShiftData.find(x => x.value == this.info.workShiftId)),
                    value: this.info.workShiftId
                }
            },
            set(obj) {
                this.info.workShiftId = obj.value;
                this.info.employeeWorkShiftByDayId = obj.employeeWorkShiftByDayId;
                if (obj) this.getWorkShiftDetails(obj.workShiftId);
                this.isShowDetails = false;
                this.subWorkShiftOptions.length = 0;
                this.subWorkShift = null;
            }
        },
        validateForm() {
            return !this.errors.any()
        },
    },
    methods: {
        isPermissionUpdate() {
            return isAPI(this, constAPI.update_in_out_update)
        },
        isPermissionAdd() {
            return isAPI(this, constAPI.update_in_out_add)
        },
        showWorkShiftDetails() {
            this.isShowDetails = true;
            this.subWorkShift = null;
        },

        hiddenWorkShiftDetails() {
            this.isShowDetails = false;
            this.info.workShiftDetailId = undefined;
            let object = this.workShiftData.find(x => x.value === this.info.workShiftId);
            if (object) {
                this.startHour = new Date(this.info.date.setHours(0, object.startHour, 0, 0));
                this.endHour = new Date(this.info.date.setHours(0, object.endHour, 0, 0));
            }
        },

        getWorkShiftDetails(id) {
            this.$vs.loading();
            this.$crm.post('work-shift/organization/find-by-id/' + id).then(response => {
                if (response.data && response.data.length > 0) {
                    this.subWorkShiftOptions = response.data.map(x => {
                        return {
                            label: x.subWorkShiftName,
                            value: x.id,
                            startHour: x.startHour,
                            endHour: x.endHour,
                            workShiftId: x.workShiftId
                        }
                    });
                    if (this.info.workShiftDetailId > 0) {
                        this.isShowDetails = true;
                        this.subWorkShift = this.subWorkShiftOptions.find(x => x.value === this.info.workShiftDetailId);
                    }
                } else {
                    this.subWorkShiftOptions = [];
                    let object = this.workShiftData.find(x => x.workShiftId === id);
                    if (object) {
                        this.startHour = new Date(this.info.date.setHours(0, object.startHour, 0, 0));
                        this.endHour = new Date(this.info.date.setHours(0, object.endHour, 0, 0));
                    }
                }
                if (this.isShowDetails == false) {
                    let object = this.workShiftData.find(x => x.workShiftId === id);
                    if (object) {
                        this.startHour = new Date(moment(this.info.date).toDate().setHours(0, object.startHour, 0, 0));
                        this.endHour = new Date(moment(this.info.date).toDate().setHours(0, object.endHour, 0, 0));
                    }
                }

                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },


        clearWorkShift() {
            this.info.workShiftId = null;
            this.info.fromHour = null;
            this.info.fromHourString = null;
            this.info.toHour = null;
            this.info.toHourString = null;
        },
        getWorkShiftByEmployee() {
            let searchInfo = {
                organizationBranchId: parseInt(this.info.organizationBranchId),
                employeeId: this.info.employeeId ? [this.info.employeeId] : null,
                start: moment(this.info.date).set({hour: 0, minute: 0, second: 0, millisecond: 0}),
                end: moment(this.info.date).set({hour: 23, minute: 59, second: 59, millisecond: 59})
            }
            this.$vs.loading();
            this.$crm.post('/time-keeping/find', searchInfo).then((response) => {
                let workShiftData = response.data.sort((item1, item2) => {
                    if (moment(item1.date) > moment(item2.date)) return 1;
                    if (moment(item1.date) < moment(item2.date)) return -1;
                    // return item1.employeeCode > item2.employeeCode ? 1 : -1
                })
                this.workShiftData = workShiftData.filter(el => el.workShiftId).map(item => {
                    item.label = item.groupName + " - " + item.workShiftName;
                    item.value = item.workShiftId;
                    item.employeeWorkShiftByDayId = item.id
                    return item;
                });

                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        changeDateInOut() {
            this.subWorkShiftOptions = [];
            if (!this.isUpdate) this.clearWorkShift();
            this.getWorkShiftByEmployee();
        },
        getLabelString(object) {
            return (object && object.label) || this.$t('menuOrganization.null');
        },
        updateTimeSpan(setting, workshift) {
            this.subWorkShift = workshift;
            this.info.workShiftDetailId = workshift.value;
            setting.fromHour = workshift.startHour;
            // this.startHour = new Date(moment(this.info.date).toDate().setHours(0, setting.fromHour, 0, 0)),
            //     setting.toHour = workshift.endHour;
            // this.endHour = new Date(moment(this.info.date).toDate().setHours(0, setting.toHour, 0, 0)),
            this.startHour = new Date(this.info.date.setHours(0, workshift.startHour, 0, 0));
            this.endHour = new Date(this.info.date.setHours(0, workshift.endHour, 0, 0));
            setting.workshift = workshift;

        },
        loadEmployee() {
            return new Promise((resolve, reject) => {
                if (!this.info.organizationBranchId) return;

                this.$vs.loading();
                this.$crm.post('/employee/find-by-organization-branch/' + this.info.organizationBranchId).then((response) => {
                    this.$vs.loading.close();
                    if (response.data && response.data.length > 0) {
                        this.employeeData = response.data;
                        this.employeeOptions = response.data.map(item => {
                            return {
                                value: item.employeeId,
                                label: item.employeeCode + "_" + item.fullName
                            }
                        });
                        if (!this.$route.query.id && !this.inOutId && (this.employeeOptions.length > 0)) this.employeeModel = this.employeeOptions[0];
                    } else {
                        this.employeeOptions = []
                        return this.$vs.notify({
                            text: 'Không tồn tại nhân viên nào',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        });
                    }
                    resolve(true);
                }).catch((err) => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Có lỗi sảy ra!',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            });
        },
        async saveChanges(evt) {

            evt.preventDefault();
            try {
                if (!this.validateForm) return;

                const result = await this.$validator.validateAll();
                if (!result) return;
                if (this.info.workShiftId == null) {
                    return this.$vs.notify({
                        title: 'Có lỗi sảy ra!',
                        text: 'Vui lòng chọn ca làm việc và xem lại ngày khiếu nại chấm công.',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                }
                let updateInOut = {
                    updateInOutId: this.info.id,
                    employeeWorkShiftByDayId: this.info.employeeWorkShiftByDayId,
                    startHour: this.startHour,
                    endHour: this.endHour,
                    employeeId: this.info.employeeId,
                    comment: this.info.comment,
                    reason: this.info.reason,
                    date: this.info.date,
                    organizationBranchId: this.info.organizationBranchId,
                    status: this.info.status,
                    workShiftDetailId: this.info.workShiftDetailId,
                    workShiftId: this.info.workShiftId,
                    fromDate: moment(this.info.date).set({hour: 0, minute: 0, second: 0, millisecond: 0}),
                    toDate: moment(this.info.date).set({hour: 23, minute: 59, second: 59, millisecond: 0})
                };

                let url = this.isUpdate ? `/work-shift/employee/assign-update-in-out/${this.info.status}` : '/work-shift/employee/admin-update-in-out';
                this.$vs.loading();
                this.$crm.post(url, updateInOut).then(() => {
                    this.$vs.loading.close();
                    this.$vs.notify({
                        color: 'success',
                        text: `${this.isUpdate ? 'Cập nhật' : 'Thêm'} thành công`,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    });
                    if (this.branchId) {
                        this.$eventBus.$emit("update-in-out-success", {});
                    } else {
                        this.inOutList();
                    }
                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });

            } catch (ex) {
                console.log(ex);
            }
        },
        inOutList() {
            this.$router.push(`/user/update-in-out`).catch(() => {
            })
        }
    },
}
</script>

<style scoped>

</style>
